export default {
  name: '',
  code: '',
  parentId: '',
  dependFrom: {}
};
